// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../SKV.NSW/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../SKV.NSW/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gray100": `#fbfbfb`,
	"gray200": `#f2f2f2`,
	"gray300": `#ebebeb`,
	"gray400": `#cdd3d6`,
	"gray500": `#d6d6d6`,
	"gray600": `#ababab`,
	"gray700": `#747474`,
	"gray800": `#495054`,
	"gray900": `#22272b`,
	"primaryColor": `#002664`,
	"secondaryColor": `#cbedfd`,
	"nswBlueColor": `#0198d2`,
	"successColor": `#008a07`,
	"infoColor": `#2e5299`,
	"warningColor": `#c95000`,
	"dangerColor": `#b81237`,
	"lightColor": `#fff`,
	"darkColor": `#22272b`,
	"linkColor": `#002664`,
	"mutedColor": `#747474`,
	"lineHeightBase": `1.5`,
	"spacer1": `.25rem`,
	"spacer2": `.5rem`,
	"spacer3": `1rem`,
	"spacer4": `1.5rem`,
	"spacer5": `3rem`,
	"spacer6": `5rem`,
	"btnPaddingY": `.625rem`,
	"btnPaddingX": `.5625rem`,
	"borderRadius": `.25rem`,
	"borderRadiusLg": `.25rem`,
	"borderRadiusSm": `.1875rem`,
	"boxShadowSm": `0 .125rem .25rem rgba(0,0,0,.075)`,
	"boxShadow": `0 .5rem 1rem rgba(0,0,0,.15)`,
	"boxShadowLg": `0 1rem 3rem rgba(0,0,0,.175)`,
	"xsBreakpoint": `0`,
	"smBreakpoint": `576px`,
	"mdBreakpoint": `768px`,
	"lgBreakpoint": `992px`,
	"xlBreakpoint": `1200px`,
	"smMaxWidth": `540px`,
	"mdMaxWidth": `720px`,
	"lgMaxWidth": `960px`,
	"xlMaxWidth": `1200px`
};
export default ___CSS_LOADER_EXPORT___;
